import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResourceRequestV2, SaveResponse } from "services/KnowfullyAdminClient";
import { Mode } from "types/common-types";
import translateError from "utils/translateError";
import ResourceForm from "./ResourceForm";

const ResourceCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const {
    resourceService,
    resourceDetailsUrl,
    resourcesUrl,
  } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "facultyFormCreateTitle" }));

  const onCancel = () => {
    navigate(resourcesUrl());
  };

  const onSubmit = async (values: ResourceRequestV2) => {
    try {
      const createdResource: SaveResponse = await registerPromise(
        resourceService.saveResource(
          ResourceRequestV2.fromJS({
            ...values,
          })
        )
      );

      queryClient.invalidateQueries("resources");
      navigate(resourceDetailsUrl(createdResource.id));

      return createdResource;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={resourcesUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="facultyFormCreateTitle" />
      </Typography>
      <ResourceForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "facultyFormCreateButton" })}
        onCancel={onCancel}
        mode={Mode.Create}
      />
    </>
  );
};

export default ResourceCreateForm;
